export class PcTrialConfig {
    // 静态资源定义
    static TRANSLATIONS = {
        'zh-cn': {
            slogan: require('@/assets/images/active/snail/fifth/mo/zh/pc_slogan.png'),
            logo: require('@/assets/images/active/snail/fifth/mo/zh/pc_logo.png'),
            btn: require('@/assets/images/active/snail/fifth/mo/zh/pc_btn.png'),
            code: require('@/assets/images/active/snail/fifth/mo/zh/in.png'),
            out: require('@/assets/images/active/snail/fifth/mo/out.png'),
            text: require('@/assets/images/active/snail/fifth/mo/zh/text.png'),
            captions: `在逃多年的<span>英雄</span>罪犯蜗牛与黄鹂鸟落网，直播公审即将开启！在逃多年的<span>英雄</span>罪犯蜗牛与黄鹂鸟落网，直播公审即将开启！在逃多年的<span>英雄</span>罪犯蜗牛与黄鹂鸟落网，直播公审即将开启！`,
            official: 'https://snail.qingcigame.com/official/',
            code_show: true
        },
        'zh-tw': {
            slogan: require('@/assets/images/active/snail/fifth/hk/pc_slogan.png'),
            logo: require('@/assets/images/active/snail/fifth/hk/pc_logo.png'),
            btn: require('@/assets/images/active/snail/fifth/hk/pc_btn.png'),
            code: require('@/assets/images/active/snail/fifth/hk/in.png'),
            out: require('@/assets/images/active/snail/fifth/mo/out.png'),
            captions: `在逃多年的<span>英雄</span>罪犯蝸牛與黃鸝鳥落網，直播公審即將開啟！在逃多年的<span>英雄</span>罪犯蝸牛與黃鸝鳥落網，直播公審即將開啟！在逃多年的<span>英雄</span>罪犯蝸牛與黃鸝鳥落網，直播公審即將開啟！`,
            official: 'https://snail.snell.com.tw/index.html',
            code_show: false
        }
    };

    constructor(lang = 'zh-cn') {
        // 参数验证
        this.lang = PcTrialConfig.validateLanguage(lang);
        this.translations = PcTrialConfig.TRANSLATIONS[this.lang];
        console.log('this.translations', this.translations);
    }

    // 语言验证方法
    static validateLanguage(lang) {
        return Object.keys(PcTrialConfig.TRANSLATIONS).includes(lang)
            ? lang
            : 'zh-cn';
    }




    // 设置语言
    setLanguage(lang) {
        this.lang = PcTrialConfig.validateLanguage(lang);
    }

    // 获取当前配置
    get config() {
        return {
            currentLanguage: this.lang,
            translations: this.translations
        };
    }
}


// WEBPACK FOOTER //
// ./src/pages/snail/5thReport/PcTrialConfig.js